import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import './plugins/ant-design-vue.js'
import './plugins/v-calendar.js'
import './plugins/vue-select.js'
import "./plugins/misUI.js";
import "vue-select/dist/vue-select.css";
import ScreenMixins from '@/mixins/ScreenCheckMixins'
import message from '@/mixins/HandleMessage'
import GlobalMethods from "@/mixins/GlobalMethods";
import appVersion from '@/mixins/Versioning'
import _ from "lodash";
//import * as VueGoogleMaps from 'vue2-google-maps'

Vue.config.productionTip = false
Vue.mixin(GlobalMethods)
Vue.mixin(ScreenMixins)
Vue.mixin(message)
Vue.mixin(appVersion)
Vue.prototype.$serviceUrl = process.env.VUE_APP_SERVICEURL
Vue.prototype.$urlPandapaKita = process.env.VUE_APP_PANDAPAKITA
Vue.prototype.$urlServiceNirmala = process.env.VUE_APP_NIRMALA
Vue.prototype._ = _
window.Event = new Vue()

const allowCrossDomain = function (req, res, next) {
  res.header('Access-Control-Allow-Origin', '*');
  res.header('Access-Control-Allow-Methods', '*');
  res.header('Access-Control-Allow-Headers', '*');
  next();
}

router.beforeEach(
  (to, from, next) => {
    const isPublic = to.matched.some(record => record.meta.isPublic);
    const layoutNonScroll = to.matched.some(record => record.meta.layoutNonScroll);
    if (isPublic) {
      store.dispatch("SET_PUBLIK", isPublic);
      next()
    } else if (layoutNonScroll) {
      store.dispatch("SET_LAYOUTNONSCROLL", layoutNonScroll);
      next()
    } else {
      next()
    }
  }
)

// Vue.use(VueGoogleMaps, {
//   load: {
//     key: 'AIzaSyBG0hobAXec9zaAv6eo4KC8wHLmikx4eyM',
//     libraries: 'places,drawing,visualization'
//   }
// });

new Vue({
  router,
  store,
  ScreenMixins,
  allowCrossDomain,
  render: h => h(App)
}).$mount('#app')
